import React, { useState, useRef } from 'react';
import RichTextEditor from 'react-rte';
import DropDown from '../Ui/DropDown';
// import Upload from '../Ui/Upload';
import UploadRef from '../Refunds/uploadRef';
import { toastMessage } from '../../utils/toast';
import * as flyerActions from '../../Redux/Actions/flyerNotification';
import { AiOutlineDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { resetFileName } from '../../utils/resetFileName';
import { useEffect } from 'react';
import Checkbox from '../Ui/Checkbox';

function FlyerNotification() {

    const { t } = useTranslation();
    const mobileRef = useRef();
    const webRef = useRef('');
    const [selectedVal, setSelectedVal] = useState('');
    const [mobileAttachments, setMobileAttachments] = useState({
        attachment: null,
        attachmentId: null
    });
    const [webAttachments, setWebAttachments] = useState({
        attachment: null,
        attachmentId: null
    });
    const [title, setTitle] = useState('');
    const [comment, setComment] = useState(RichTextEditor.createEmptyValue());
    const [buttonLoading, setButtonLoading] = useState(false);
    const [deeplink, setDeeplink] = useState({
        flag: false,
        options: [],
        errorFlag: false
    });
    const [departmentId, setDepartmentID] = useState('');
    const [masterProcessId, setMasterProcessID] = useState('');
    const [processId, setProcessID] = useState('');
    const [departmentList, setDepartmentList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [processData, setProcessData] = useState({
        options: [],
        selectedFormId: ''
    });

    const toolbarConfig = {
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
    };

    const options = [
        { label: "Admin", value: "SUPERADMIN" },
        { label: "CSP", value: "TYPINGCENTER" },
        { label: "Customers", value: "CUSTOMER" },
    ];

    useEffect(() => {
        getProcessApi();
    }, []);

    useEffect(() => {
        console.log(processId.value);
        if(processId.value) {
            const { formId } = processData.options.find(item => item.id === processId.value);
            setProcessData((prevState) => ({...prevState, selectedFormId: formId}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processId]);

    const uploadAdditionalPaymentReference = (setState) => (event) => {
        const files = event.target.files[0];
        if(!files) {
            return;
        }

        let data = new FormData();
        data.append('file', resetFileName(files));
        let woExtensionName = files?.name.toLowerCase().split('.');
        if(!(['jpeg', 'jpg', 'png'].includes(woExtensionName[woExtensionName?.length-1]))) {
            toastMessage('error', 'Un Supported Media type!');
            return;
        } 

        setState((preState) => ({...preState, attachment: files}));
        data.append('fileName', files.name.toLowerCase());
        data.append('extension', '.' + woExtensionName[woExtensionName?.length-1]);

        flyerActions.uploadBanner(data).then(res => {
            if(res?.data){
                setState((preState) => ({...preState, attachmentId: res.data}));
            }
        }).catch(err => {
            toastMessage('error', (err?.message) || `Unable to upload the document`);
        });
    }

    const handleSend = () => {
        if(deeplink.flag) {
            if(!processData.selectedFormId) {
                setDeeplink((prevState) => ({...prevState, errorFlag: true }));
                return;
            }
        }

        if(deeplink.errorFlag) {
            setDeeplink((prevState) => ({...prevState, errorFlag: false }));
        }

        setButtonLoading(true);
        const payload = {
            message: comment.toString('html'),
            title,
            documentId: mobileAttachments.attachmentId,
            documentIdForWeb: webAttachments.attachmentId,
            userIds: [],
            userRoles: [ selectedVal?.value ],
            isDeepLink: deeplink.flag,
            processId: processId.value,
            formId: processData.selectedFormId
        }

        flyerActions.createNotification(payload).then(res => {
            if(res?.status === 200) {
                toastMessage('success', 'Flyer Notification send Successfully');
                window.location.reload();
            } else {
                toastMessage('error', 'Unable to send flyer Notification');
            }
            setButtonLoading(false);
        }).catch((err) => {
            setButtonLoading(false);
            toastMessage('error', 'Unable to send flyer Notification');
        })
    }

    const changeHandler = () => {
       setMobileAttachments({ attachment: null, attachmentId: null });
       setWebAttachments({ attachment: null, attachmentId: null });
       setComment(RichTextEditor.createEmptyValue());
       setTitle("");
       setDeeplink((prevState) => ({...prevState, flag: false }));
    }

    const getProcessApi = async () => {
        const { data } = await flyerActions.getProcess();        
        setDeeplink((prevState) => ({...prevState, options: data.department }));
        let departmentsList = data.department;
        departmentsList = departmentsList.map(({name, id, masterProcess}) => ({"label": name, "value": id, "masterProcess": masterProcess}));
        departmentsList.unshift({label: "Select Department", "value": 0, "masterProcess": [] });
        setDepartmentList(departmentsList);
    }

    const handleList = (key, ID) => {
        let list = [];
        if(key === 'department'){
            list = departmentList.filter(({value}) => value === ID)[0].masterProcess;
            list = list.map(({name, id, process}) => ({"label": name, "value": id, "process": process}));
            list.unshift({label: "Select Department", "value": 0, "process": [] });
            setMasterProcessList(list);
            setProcessList([]);
            setMasterProcessID('');
            setProcessID('');
        }else{
            list = masterProcessList.filter(({value}) => value === ID)[0].process;
            setProcessData((prevState) => ({...prevState, options: [...list]}));
            list = list.map(({name, id}) => ({"label": name, "value": id}));
            list.unshift({label: "Select Master process", "value": 0 });
            setProcessList(list);
        }
    }
    
  return (
    <div className="container-fluid">
        <div className="page-title-box">
            <h4 className="page-title mb-2">{t('flyerNotification.title')}</h4>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div className="card card-custom card-stretch gutter-b">
                    <div className="card-body py-3">
                        <div className="tab-content">
                            <div className='d-flex flex-column'>
                                <div className='d-flex row'>
                                    <div className='col-lg-4'>
                                        <div>
                                        <DropDown label={t('flyerNotification.selectGroup')} placeholder={t('flyerNotification.selectGroup')} options={options} value={selectedVal} onChange={value => {setSelectedVal(value); changeHandler();}} />
                                        </div>
                                        <div>
                                            <label className='me-3'>{t('flyerNotification.titleMsgPlaceholder')}</label>
                                            <input className='form-control' placeholder={t('flyerNotification.titleMsgPlaceholder')} type="text" value={title} onChange={e => setTitle(e.target.value)} />
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <div className="my-3 d-flex flex-column">
                                                <label className='my-2'>{t('flyerNotification.uploadImg')}</label>
                                                <div className="d-flex align-items-center">
                                                    <UploadRef documentRef={mobileRef} onChange={uploadAdditionalPaymentReference(setMobileAttachments)} />
                                                    {mobileAttachments.attachmentId && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setMobileAttachments({ attachment: null, attachmentId: null }); mobileRef.current.value = "";}} />}
                                                </div>
                                            </div>
                                            {selectedVal?.value === 'CUSTOMER' ? <div className="my-3 d-flex flex-column">
                                                <label className='my-2'>{t('flyerNotification.uploadImgForWeb')}</label>
                                                <div className="d-flex align-items-center">
                                                    <UploadRef documentRef={webRef} onChange={uploadAdditionalPaymentReference(setWebAttachments)} />
                                                    {webAttachments.attachmentId && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setWebAttachments({ attachment: null, attachmentId: null }); webRef.current.value = "";}} />}
                                                </div>
                                            </div> : null}
                                        </div>
                                        <div className='my-3'>
                                            <label className="me-3">{t('flyerNotification.message')}</label>
                                            <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={comment} onChange={value => setComment(value)} />
                                        </div>
                                    </div>
                                    <div className="col-lg-1"></div>
                                    <div className='col-lg-6'>
                                        {mobileAttachments.attachment && mobileAttachments.attachment?.type?.includes('image') && <img className='mx-3' alt="Document Preview" src={URL.createObjectURL(mobileAttachments.attachment)} style={{ width: '256px', height: '455px'}}/>}
                                        {webAttachments.attachment && webAttachments.attachment?.type?.includes('image') && <img alt="Document Preview" src={URL.createObjectURL(webAttachments.attachment)} style={{ width: '256px', height: '455px'}}/>}
                                    </div>
                                    {/* <div className="col-lg-1"></div>
                                    <div className='col-lg-6'>
                                        {webAttachments.attachment && webAttachments.attachment?.type?.includes('image') && <img alt="Document Preview" src={URL.createObjectURL(webAttachments.attachment)} style={{ width: '256px', height: '455px'}}/>}
                                    </div> */}
                                </div>
                                {/* <div className='d-flex'>
                                    <input checked={deeplink.flag} onChange={() => setDeeplink((prevState) => ({...prevState, flag: !deeplink.flag}))} type="checkbox" />
                                    <label className='mx-1'>is Deep link</label>
                                </div> */}
                                {selectedVal?.value === "CUSTOMER" ? <Checkbox label={t('flyerNotification.isDeepLink')} onChange={() => setDeeplink((prevState) => ({...prevState, flag: !deeplink.flag}))} value={deeplink.flag} /> : null }
                                { deeplink.flag && selectedVal?.value === "CUSTOMER" ?
                                    <div className='d-flex'>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelDepartment")} placeholder={t("jobSla.filters.selectDepartment")} options={departmentList} value={departmentId} onChange={value => {setProcessList([]); handleList('department', value.value); setDepartmentID(value); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelMasterProcess")} placeholder={t("jobSla.filters.selectMasterProcess")} options={masterProcessList} value={masterProcessId} onChange={value => {handleList('masterProcess', value.value); setMasterProcessID(value); }} />
                                        </div>
                                        <div className="me-3" style={{ width: '100%' }}>
                                            <DropDown isSearchable={true} label={t("jobSla.filters.labelprocess")} placeholder={t("jobSla.filters.selectprocess")} options={processList} value={processId} onChange={value => {setProcessID(value);}} />
                                        </div>
                                    </div> : null
                                }
                                {deeplink.errorFlag ? <p className='text-danger'>{t('flyerNotification.mandatoryField')}</p> : null}
                                <div className='d-flex justify-content-end'>
                                    <button className='btn btn-primary d-flex align-items-center' disabled={buttonLoading || (title && selectedVal?.value && comment ? false: true)} onClick={() => handleSend()}>
                                        {t('flyerNotification.send')}{buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FlyerNotification;